import fetchBusinessBudget from 'actions/businessTraveller/fetchBusinessBudget'
import generateBusinessBudgetKey from 'businessTraveller/utils/generateBusinessBudgetKey'
import GeoContext from 'contexts/geoContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useContext, useEffect, useMemo } from 'react'
import config from 'constants/config'
import useQueryParams from 'hooks/useQueryParams'
import { getDestinationIdFromURLSearchParams } from 'lib/url/searchUrlUtils'

function useBusinessTravellerBusinessBudgetMapFetcher() {
  const { currentCurrency } = useContext(GeoContext)
  const appDispatch = useAppDispatch()
  const businessId = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.business?.id)
  const queryParams = useQueryParams()
  const businessMapBudget = useAppSelector(state => state.businessTraveller.businessMapBudget)

  const placeId = getDestinationIdFromURLSearchParams(queryParams)

  const {
    toBeCalculatedBusinessBudget,
    budgetKey,
  } = useMemo(() => {
    const toBeCalculatedBudget: App.BusinessTraveller.ToBeCalculatedBusinessBudget = {
      currencyCode: currentCurrency,
      lePlaceId: placeId,
    }

    const key = generateBusinessBudgetKey(toBeCalculatedBudget)

    return {
      toBeCalculatedBusinessBudget: toBeCalculatedBudget,
      budgetKey: key,
    }
  }, [currentCurrency, placeId])

  useEffect(() => {
    if (config.businessTraveller.currentAccountMode === 'business' && businessId && toBeCalculatedBusinessBudget && placeId) {
      appDispatch(fetchBusinessBudget(businessId, [budgetKey, toBeCalculatedBusinessBudget], true))
    }
  }, [appDispatch, budgetKey, businessId, placeId, toBeCalculatedBusinessBudget])

  return {
    businessMapBudget,
    budgetKey,
    toBeCalculatedBusinessBudget,
  }
}

export default useBusinessTravellerBusinessBudgetMapFetcher
